<div class="container padding-top-10 padding-bottom-10 relatorio-visita-customizado">
  <uib-alert ng-show="url" type="info">
    <a ng-href="{{url}}">
      Relatório gerado com sucesso! <strong>Clique aqui para baixar</strong>
    </a>
  </uib-alert>

  <uib-alert ng-show="htmlLink" type="success">
    <a target="_blank" ng-href="{{htmlLink}}">
      <strong>Ou clique aqui para visualizar versão WEB COMPARTILHÁVEL</strong>
    </a>
  </uib-alert>

  <div class="row" ng-if="configInicial.data">
    <div class="col-xs-12">
      <div class="page-header">
        <div class="btn-toolbar pull-right">
          <div class="btn-group">
            <button class="btn btn-link" ng-disabled="!glebas || gerando || !isReady()" ng-click="reset()">
              Restaurar
              <i class="fa fa-undo"></i>
            </button>
            <button class="btn" ng-class="statusInfestationMaps === 'success' ? 'btn-primary' : 'btn-white'" ng-disabled="statusInfestationMaps === 'loading' || !isReady()" ng-click="generateInfestationMaps()">
              Gerar mapas de infestação
              <span ng-if="statusInfestationMaps === 'loading'"><i class="fa fa-spinner fa-spin"></i></span>
              <span ng-if="statusInfestationMaps !== 'loading'"><i class="fa fa-map-o"></i></span>
            </button>
            <button class="btn btn-white" ng-disabled="!glebas || gerando || !isReady()" ng-click="voltar()">
              Voltar
              <i class="fa fa-calendar"></i>
            </button>
            <button class="btn btn-success" ng-disabled="!glebas || gerando || !isReady()" ng-click="gerarRelatorio()">
              Gerar
              <span ng-if="gerando"><i class="fa fa-spinner fa-spin"></i></span>
              <span ng-if="!gerando"><i class="fa fa-file-text-o"></i></span>
            </button>
          </div>
        </div>
        <h2>Relatório de Visitas - <b>Data: {{configInicial.data | date:'dd/MM'}}</b></h2>
      </div>
    </div>
  </div>

  <div class="jumbotron" ng-if="!configInicial.data && !relatorioId">
    <h1>Relatório de Visita</h1>

    <p>Selecione uma data ou <a href="/#!/relatorios">vá para a lista de relatórios já gerados.</a></p>
    <p class="input-group">
      <input type="text"
          readonly
          datepicker-options="datePickerOptionsGeral"
          uib-datepicker-popup="dd/MM/yyyy"
          ng-model="filters.data"
          class="form-control"
          ng-required="true"
          is-open="popup2.opened"
          ng-click="popup2.opened = !popup2.opened">
      <span class="input-group-btn">
        <button ng-disabled="relatorio.gerando" type="button" class="btn btn-default" ng-click="popup2.opened = !popup2.opened"><i class="glyphicon glyphicon-calendar"></i></button>
      </span>
    </p>
    <p>
    <div class="col-xs-12 text-center padding-5" ng-show="loading">
      <i class="fa fa-2x fa-spinner fa-spin"></i>&nbsp;
    </div>
    <div class="form-group" ng-if=usuarios.length>
      <label for="usuarios" class="control-label">Usuário (deixe vazio para selecionar Todos)</label>
      <ui-select multiple ng-model="filters.usuarios" theme="bootstrap">
        <ui-select-match allow-clear="true">{{$item.nomeCompleto | capitalize}}</ui-select-match>
        <ui-select-choices repeat="usuario in usuarios | filter: {nomeCompleto:$select.search}">
          <span ng-bind-html="usuario.nomeCompleto | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    </p>
    <p><button class="btn btn-primary btn-lg" type="button" ng-disabled="!filters.data && !filters.usuario" ng-click="checkExistsAndGoToReport(filters)">Iniciar geração</button></p>

    <small ng-if="parametros.modelo_relatorio_visita">Modelo de relatório: {{::parametros.modelo_relatorio_visita.descricao}}</small>
  </div>

  <div class="row" ng-if="configInicial.data">
    <div class="col-xs-12">
      <uib-tabset active="activeTab">
        <uib-tab index="0">
          <uib-tab-heading>Geral</uib-tab-heading>
          <div class="row no-margin padding-top-5">
            <div class="col-xs-12 no-padding">
              <ng-ckeditor ng-model="configInicial.conteudoGeral" ng-config="editorConfig"></ng-ckeditor>
            </div>
            <div class="col-xs-12">
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="configInicial.quebrarAtividade" ng-change="getAtividades()"> Quebrar por cultura
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="configInicial.quebrarPorGleba" ng-change="getAtividades()"> Quebrar por talhão
                </label>
              </div>
            </div>

            <div class="col-xs-12 text-center padding-5" ng-show="atividades.loading">
              <i class="fa fa-2x fa-spinner fa-spin"></i>&nbsp;
            </div>

            <div class="col-xs-12 no-padding padding-top-5" ng-hide="atividades.loading" ng-repeat="(key,atividade) in atividades.dados">
              <div class="panel panel-default">
                <div class="panel-heading">{{atividade.descricao | capitalize}}</div>
                <div class="panel-body">
                  <ng-ckeditor ng-model="atividade.texto" ng-config="editorConfig"></ng-ckeditor>
                </div>
              </div>
            </div>
          </div>
        </uib-tab>

        <uib-tab index="$index + 1" ng-repeat="gleba in glebas | orderBy:'descricao' track by gleba.id" select="getDatasGlebas(gleba)">
          <uib-tab-heading>
            {{::gleba.descricao | capitalize}}
            <span class="badge badge-primary" ng-show="!gleba.loading">{{gleba.dados.length}}</span>
            <span class="badge badge-danger" ng-show="!gleba.loading && gleba.dadosDescartados.length">{{gleba.dadosDescartados.length}}</span>
            <span ng-show="gleba.loading">
              <i class="fa fa-spinner fa-spin"></i>&nbsp;
            </span>
          </uib-tab-heading>

          <div class="row no-margin padding-top-5">
            <div class="col-xs-12 col-md-8 selected" ui-sortable="mainSortableOptions[gleba.id]" ng-model="gleba.dados" ng-class="'dados-{{gleba.id}}'">
              <div class="panel panel-default m-b-xs panel-drag" ng-repeat="item in gleba.dados">
                <div class="panel-body no-padding">
                  <div class="icon-area" ng-include="'icon.html'"></div>
                  <div class="text-area">
                    <div class="row no-margin">
                      <div class="col-xs-12 col-sm-4 col-md-3 col-lg-2 photos-wrap"
                           ng-repeat="imagem in item.imagens track by $index">
                        <div class="photo-box pointer">
                          <div class="image-wrap" ng-class="{'disabled': imagem.disabled}">
                            <img ng-src="{{imagem.editedURL || imagem.thumb}}">
                            <i class="fa fa-ban text-danger"></i>
                          </div>
                          <div class="menu text-center">
                            <button title="Girar à esquerda" type="button" class="btn-link text-info btn-xs" ng-click="rotateImage(imagem, 'left')" ng-disabled="imagem.disabled || processing">
                              <span ng-hide="imagem.processing"><i class="fa fa-undo"></i></span>
                              <span ng-show="imagem.processing"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                            <button title="Girar à direita" type="button" class="btn-link text-info btn-xs" ng-click="rotateImage(imagem, 'right')" ng-disabled="imagem.disabled || processing">
                              <span ng-hide="imagem.processing"><i class="fa fa-repeat"></i></span>
                              <span ng-show="imagem.processing"><i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                            <button type="button" class="btn-link text-info btn-xs" ng-click="editImage(imagem)" ng-disabled="imagem.disabled || processing">
                              <i class="fa fa-edit"></i>
                            </button>
                            <button type="button" class="btn-link btn-xs" ng-click="toggleDisableImage(imagem)" ng-class="{'text-danger': !imagem.disabled, 'text-success': imagem.disabled}">
                              <i class="fa" ng-class="{'fa-trash': !imagem.disabled, 'fa-check': imagem.disabled}"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 no-padding">
                        <ng-ckeditor ng-model="item.conteudo" ng-config="editorConfig" ng-if="!dragging"></ng-ckeditor>
                        <p ng-if="dragging" ng-bind-html="item.conteudo | trusted"></p>
                        <button type="button" class="btn-link btn-xs pull-right" ng-click="discard(gleba, item)">
                          Descartar dado
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-md-4">
              <div class="panel panel-default m-b-xs panel-drag">
                <div class="panel-heading input-group padding-5" ng-if="showCalendar">
                  <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Dia"
                         uib-datepicker-popup="dd/MM/yyyy" is-open="popup[gleba.id].opened"
                         show-button-bar="false" datepicker-append-to-body="true"
                         ng-click="popup[gleba.id].opened = !popup[gleba.id].opened"
                         ng-model="gleba.dia" ng-change="getGlebaDia(gleba)">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default btn-sm" ng-click="popup[gleba.id].opened = !popup[gleba.id].opened">
                      <i class="glyphicon glyphicon-calendar"></i>
                    </button>
                  </span>
                </div>
              </div>
              <div class="text-center padding-5" ng-show="gleba.loading">
                <i class="fa fa-2x fa-spinner fa-spin"></i>&nbsp;
              </div>
              <div class="panel panel-default m-b-xs panel-drag" ng-hide="gleba.loading">
                <button type="button" class="btn btn-default width-100" ng-click="addCustomContent(gleba)">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                  Adicionar conteúdo customizado
                </button>
              </div>
              <div class="panel panel-default m-b-xs panel-drag" ng-hide="gleba.loading">
                <button type="button" class="btn btn-info width-100" ng-click="addSummary('ocorrencias', gleba)">
                  <i class="fa fa-plus-circle" aria-hidden="true"></i>
                  Resumo de ocorrências
                </button>
              </div>
              <div class="panel panel-default m-b-xs panel-drag" ng-hide="gleba.loading">
                <button type="button" class="btn btn-info width-100" ng-click="addSummary('ocorrencias', gleba, true)">
                  <i class="fa fa-plus-circle" aria-hidden="true"></i>
                  Resumo de ocorrências por cultivar
                </button>
              </div>
              <div class="panel panel-default m-b-xs panel-drag" ng-hide="gleba.loading">
                <button type="button" class="btn btn-info width-100" ng-click="addSummary('medias_afericoes', gleba)">
                  <i class="fa fa-plus-circle" aria-hidden="true"></i>
                  Média de aferições
                </button>
              </div>
              <div ui-sortable="discardedSortableOptions[gleba.id]" ng-model="gleba.dadosDescartados" ng-class="'discarded-{{gleba.id}}'" class="not-selected" ng-if="gleba.dadosDescartados.length">
                <div class="panel panel-default m-b-xs panel-drag" ng-repeat="item in gleba.dadosDescartados" ng-hide="gleba.loading">
                  <div class="panel-body no-padding">
                    <div class="icon-area" ng-include="'icon.html'"></div>
                    <div class="text-area">
                      <div ng-bind-html="item.conteudo | trusted" ng-hide="item.tipo === 'medias_afericoes'"></div>
                      <div ng-show="item.tipo === 'medias_afericoes'">
                        <h2>Médias das Aferições</h2>
                      </div>
                      <button type="button" class="btn-link btn-xs" ng-click="restore(gleba, item)">
                        <i class="fa fa-plus"></i>
                        Restaurar dado
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </uib-tab>
        <uib-tab index="glebas.length + 1">
          <uib-tab-heading>Informações Adicionais</uib-tab-heading>
          <div class="row no-margin padding-top-5">
            <div class="col-xs-12">
              <!--Recomendações de outras datas -->
              <div class="ibox">
                <div class="ibox-title">
                  <h5>Informações adicionais</h5>
                </div>
                <div class="ibox-content">
                  <label>Recomendações a partir de</label>
                  <div class="input-group">
                    <input type="text" class="form-control input-sm" readonly datepicker-options="datePickerOptions" placeholder="Dia"
                    uib-datepicker-popup="dd/MM/yyyy" is-open="popupDia.opened"
                    show-button-bar="false" datepicker-append-to-body="true"
                    ng-click="popupDia.opened = !popupDia.opened"
                    ng-model="configInicial.dataRecomendacao" ng-change="getRecomendacoesDia()">
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-default btn-sm" ng-click="popupDia.opened = !popupDia.opened">
                        <i class="glyphicon glyphicon-calendar"></i>
                      </button>
                    </span>
                  </div>
                  <p class="text-cinza margin" ng-show="loading">
                    <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
                  </p>
                  <div class="sortable-recommendations" ui-sortable="sortableRecommendations" ng-model="recomendacoes" ng-hide="loading">
                    <div class="checkbox" ng-repeat="recomendacao in recomendacoes">
                      <div class="handle">
                        <i class="fa fa-sort"></i>
                      </div>
                      <label>
                        <input type="checkbox" ng-model="recomendacao.selected"> {{recomendacao.glebas | getTextItems}}
                         - {{recomendacao.grupo_insumos | orderBy:'descricao' | getTextItems | capitalize}}
                         - {{recomendacao.data_inicio | date:'dd/MM'}} à {{recomendacao.data_termino | date:'dd/MM'}}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!--Fim Recomendações de outras datas -->

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="configInicial.incluirAssinaturas">
                  Incluir área para assinaturas
                </label>
              </div>

              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="configInicial.incluirProximaVisita">
                  Incluir próxima visita
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="configInicial.personalizarLogotipo">
                  Personalizar logo
                </label>
              </div>

              <label ng-if="configInicial.personalizarLogotipo">Logotipo personalizado</label>
              <div class="input-group" ng-if="configInicial.personalizarLogotipo">
                <div class="row">
                  <div class="col-xs-6">
                    <input class="input-sm"
                      ng-model="configInicial.logotipo"
                      id="logotipo"
                      type="file"
                      accept="image/*"
                      file-input
                      ng-change="fileNameChanged()">
                  </div>
                  <div class="col-xs-6" ng-show="configInicial.logotipo">
                    <img ng-src="{{configInicial.logotipo}}" class="img-responsive margin-center">
                  </div>
                </div>
              </div>

              <label ng-if="configInicial.incluirProximaVisita">Próxima Visita</label>
              <div class="input-group" ng-if="configInicial.incluirProximaVisita">
                <input type="text" class="form-control input-sm" readonly datepicker-options="datePickerOptions" placeholder="Dia"
                       uib-datepicker-popup="dd/MM/yyyy" is-open="popupDataProximaVisita.opened"
                       show-button-bar="false" datepicker-append-to-body="true"
                       ng-click="popupDataProximaVisita.opened = !popupDataProximaVisita.opened"
                       ng-model="configInicial.dataProximaVisita">
                <span class="input-group-btn">
                  <button type="button" class="btn btn-default btn-sm" ng-click="popupDataProximaVisita.opened = !popupDataProximaVisita.opened">
                    <i class="glyphicon glyphicon-calendar"></i>
                  </button>
                </span>
              </div>

              <label>Responsável da Fazenda</label>
              <div class="input-group width-100">
                <input class="form-control" ng-model="configInicial.responsavel" type="text" id="responsavel" name="responsavel">
              </div>
            </div>
          </div>
        </div>
        </uib-tab>
      </uib-tabset>
    </div>
  </div>
</div>

<script type="text/ng-template" id="icon.html">
  <i ng-hide="item.tipo == 'customizado'" agro-icon-historico historico="{tipo: item.tipo}"></i>
  <i ng-show="item.tipo == 'customizado'" class="fa fa-info-circle" aria-hidden="true"></i>
</script>
<script type="text/ng-template" id="summaryTable.html">
  <table class="detalhes">
    <thead>
      <tr>
        <th colspan="2">
          {{descricao}} <small><i>({{cientifico}})</i></small>
        </th>
      </tr>
    </thead>
    <tbody>
      %body%
    </tbody>
  </table>
</script>
<script type="text/ng-template" id="summaryTable-boolean.html">
  <tr>
    <td>{{descricao | capitalize}}:</td>
    <td>{{summarize ? 'Sim' : 'Não'}}</td>
  </tr>
</script>
<script type="text/ng-template" id="summaryTable-percentual.html">
  <tr>
    <td>{{descricao | capitalize}}:</td>
    <td>{{summarize.percentual | number:2}}% em {{quantidade_pontos}} pontos</td>
  </tr>
</script>
<script type="text/ng-template" id="summaryTable-contagem_plantas.html">
  <tr>
    <td>Entre nós atacados:</td>
    <td>{{summarize.percentual | number:2}}%</td>
  </tr>
</script>
<script type="text/ng-template" id="summaryTable-texto.html">
  <tr>
    <td>{{descricao | capitalize}}:</td>
    <td>
      %text%
    </td>
  </tr>
</script>
<script type="text/ng-template" id="summaryTable-texto-text.html">
  <p>
    <b>{{situacao_to_pt_br}}:</b> {{pontos_totais}} ponto(s)
  </p>
</script>
<script type="text/ng-template" id="summaryTable-valor.html">
  <tr>
    <td>{{descricao | capitalize}}:</td>
    <td>
      {{summarize}}
      {{summarize ? '('+(summarize / pontos_totais | number:1)+'/ponto)' : ''}}
    </td>
  </tr>
</script>

<script type="text/ng-template" id="summaryTableAfericoes-Colheita.html">
  <table class="detalhes">
    <thead>
    <tr>
      <th>Máquina</th>
      <th>Pontos</th>
      <th>Máxima</th>
      <th>Minima</th>
      <th>Média</th>
      <th>Data Inicial</th>
      <th>Data Final</th>
    </tr>
    </thead>
    <tbody>
    %body%
    </tbody>
  </table>
</script>
<script type="text/ng-template" id="summaryTableAfericoes-afericao-Colheita.html">
  <tr>
    <td>{{descricao | capitalize}}</td>
    <td>{{pontos | number}}</td>
    <td>{{maxima | number:2}}</td>
    <td>{{minima | number:2}}</td>
    <td>{{media | number:2}}</td>
    <td>{{data_inicial | date:'dd/MM/yy HH:mm'}}</td>
    <td>{{data_final | date:'dd/MM/yy HH:mm'}}</td>
  </tr>
</script>
<script type="text/ng-template" id="summaryTableAfericoes-Semeadura.html">
  <table class="detalhes">
    <thead>
      %head%
    </thead>
    <tbody>
      %body%
    </tbody>
  </table>
</script>
<script type="text/ng-template" id="summaryTableAfericoes-afericao-Semeadura.html">
  <tr>
    <td>{{descricao | capitalize}}</td>
    <td>{{tipo == 0 ? (tipo_medida || 'Semente') : (tipo_medida || 'Adubo') | capitalize}}</td>
    <td>{{pontos | number}}</td>
    <td>{{maxima | number:2}}</td>
    <td>{{minima | number:2}}</td>
    <td>{{media | number:2}}</td>
    <td>{{data_inicial | date:'dd/MM/yy HH:mm'}}</td>
    <td>{{data_final | date:'dd/MM/yy HH:mm'}}</td>
    %totais_cana%
  </tr>
</script>

